"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _label = _interopRequireDefault(require("./label"));

var _rowModule = _interopRequireDefault(require("./row.module.scss"));

var _fieldsize = _interopRequireWildcard(require("../form/fieldsize"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "children", "label", "labelClassname", "wrapperClassName", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Row = function Row(_ref) {
  var _cx;

  var className = _ref.className,
      children = _ref.children,
      label = _ref.label,
      labelClassname = _ref.labelClassname,
      wrapperClassName = _ref.wrapperClassName,
      size = _ref.size,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classNames = (0, _classnames.default)(_rowModule.default.Row, className, (_cx = {}, (0, _defineProperty2.default)(_cx, _rowModule.default.RowDefault, size === _fieldsize.default.DEFAULT), (0, _defineProperty2.default)(_cx, _rowModule.default.RowSmall, size === _fieldsize.default.SMALL), _cx));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(_rowModule.default.rowWrapper, wrapperClassName)
  }, restProps), label && /*#__PURE__*/_react.default.createElement(_label.default, {
    className: labelClassname
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: classNames
  }, children));
};

Row.propTypes = {
  size: _propTypes.default.string,
  className: _propTypes.default.string,
  labelClassname: _propTypes.default.string,
  wrapperClassName: _propTypes.default.string,
  label: _propTypes.default.string,
  children: _propTypes.default.node
};
Row.defaultProps = _objectSpread({}, _fieldsize.fieldSizeDefaultProps);
var _default = Row;
exports.default = _default;